import {
    CollectionPhase,
    CollectionPolicy,
    CollectionRule,
} from '../components/pages/billing/collection/collectionModel';

const buildRuleRequest = (rule: CollectionRule): Record<string, unknown> => ({
    phase: rule.phase,
    channel: rule.channel,
    obligorRole: rule.obligorRole,
    criteria: {
        fromDaysPastDue: rule.criteria.fromDaysPastDue,
        assignorCount: rule.criteria.assignorCount == null ? null : Number(rule.criteria.assignorCount),
        receivingAccountKind: rule.criteria.receivingAccountKind,
        paymentInstruction: rule.criteria.paymentInstruction,
    },
    messageCompositionId: rule.skip ? null : rule.messageCompositionId,
    skip: rule.skip,
});

const hasRules = (policy: CollectionPolicy, phase: CollectionPhase) => policy.rules.some(rule => rule.phase === phase);

const toNumber = (value: unknown): number | null => (value == null || value === '' ? null : Number(value));

const buildSchedulesRequest = (policy: CollectionPolicy): Record<string, unknown> => {
    const { preventive, overdue } = policy.schedules;
    return {
        preventive: hasRules(policy, 'PREVENTIVE') && preventive
            ? { daysBefore: [...preventive.daysBefore].map(Number).sort((a, b) => b - a), nonBusinessDayRule: preventive.nonBusinessDayRule }
            : null,
        overdue: hasRules(policy, 'OVERDUE') && overdue
            ? { firstAfterDays: toNumber(overdue.firstAfterDays), everyDays: toNumber(overdue.everyDays), nonBusinessDayRule: overdue.nonBusinessDayRule }
            : null,
    };
};

export const buildPolicyRequest = (policy: CollectionPolicy): Record<string, unknown> => ({
    name: policy.name.trim(),
    description: policy.description.trim() || null,
    schedules: buildSchedulesRequest(policy),
    rules: policy.rules.map(buildRuleRequest),
});
